import axios from "axios"
import { Analytic } from "../../utils/analytics"
import { Dispatch, RNBThunkAction } from "../store.config"

const enum AnalyticsActionsEnum {
  ADD_ANALYTICS_ATTEMPT = "ANALYTICS/addAnalyticsAttempt",
  ADD_ANALYTICS_SUCCESS = "ANALYTICS/addAnalyticsSuccess",
  ADD_ANALYTICS_ERROR = "ANALYTICS/addAnalyticsErrror",
  UPDATE_ANALYTICS_ATTEMPT = "ANALYTICS/updateAnalyticsAttempt",
  UPDATE_ANALYTICS_SUCCESS = "ANALYTICS/updateAnalyticsSuccess",
  UPDATE_ANALYTICS_ERROR = "ANALYTICS/updateAnalyticsErrror",
  DELETE_ANALYTICS_ATTEMPT = "ANALYTICS/deleteAnalyticsAttempt",
  DELETE_ANALYTICS_SUCCESS = "ANALYTICS/deleteAnalyticsSuccess",
  DELETE_ANALYTICS_ERROR = "ANALYTICS/deleteAnalyticsErrror",
  GET_ANALYTICS_ATTEMPT = "ANALYTICS/getAnalyticsAttempt",
  GET_ANALYTICS_SUCCESS = "ANALYTICS/getAnalyticsSuccess",
  GET_ANALYTICS_ERROR = "ANALYTICS/getAnalyticsErrror",
  IMPORT_FROM_FULLL_ANALYTICS_ATTEMPT = "ANALYTICS/importFromFulllAnalyticsAttempt",
  IMPORT_FROM_FULLL_ANALYTICS_SUCCESS = "ANALYTICS/importFromFulllAnalyticsSuccess",
  IMPORT_FROM_FULLL_ANALYTICS_ERROR = "ANALYTICS/importFromFulllAnalyticsErrror",

  EDIT_ANALYTIC = "ANALYTICS/editAnalytic",
}
export const LIMIT_BY_ACCOUNTING_SOFTWARE = {
  acd: 5,
  quadratus: 10,
  isacompta: 6,
  cegid: 2,
  cegid_11: 2,
  loop: 2,
  my_unisoft: 2,
  revor: 6,
} as const

export const ACCOUNTING_SOFTWARE_WITH_ADDABLE_ANALYTICS = [
  "acd",
  "quadratus",
  "isacompta",
  "cegid",
  "cegid_11",
  "loop",
  "my_unisoft",
  "revor",
  "coala",
]

export const addAnalyticsAttemptAction = () =>
  ({ type: AnalyticsActionsEnum.ADD_ANALYTICS_ATTEMPT } as const)

export const addAnalyticsSuccessAction = () =>
  ({
    type: AnalyticsActionsEnum.ADD_ANALYTICS_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "analytics_axes.toaster.title",
      bodyKey: "analytics_axes.toaster.body",
    },
  } as const)

export const addAnalyticsErrorAction = () =>
  ({
    type: AnalyticsActionsEnum.ADD_ANALYTICS_ERROR,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "analytics_axes.toaster.error.title",
      bodyKey: "analytics_axes.toaster.error.body",
    },
  } as const)

export const addAnalyticsTooLongErrorAction = (errorData?: {
  current_length: number
  limit: number
  accounting_software: string
}) =>
  ({
    type: AnalyticsActionsEnum.ADD_ANALYTICS_ERROR,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "analytics_axes.toaster.too_long.title",
      bodyKey: "analytics_axes.toaster.too_long.body",
      bodyValues: errorData,
    },
  } as const)

export const updateAnalyticsAttemptAction = () =>
  ({ type: AnalyticsActionsEnum.UPDATE_ANALYTICS_ATTEMPT } as const)

export const updateAnalyticsSuccessAction = () =>
  ({
    type: AnalyticsActionsEnum.UPDATE_ANALYTICS_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "analytics_axes.toaster.title",
      bodyKey: "analytics_axes.toaster.body",
    },
  } as const)

export const updateAnalyticsErrorAction = () =>
  ({
    type: AnalyticsActionsEnum.UPDATE_ANALYTICS_ERROR,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "analytics_axes.toaster.error.title",
      bodyKey: "analytics_axes.toaster.error.body",
    },
  } as const)

export const deleteAnalyticsAttemptAction = () =>
  ({ type: AnalyticsActionsEnum.DELETE_ANALYTICS_ATTEMPT } as const)

export const deleteAnalyticsSuccessAction = () =>
  ({ type: AnalyticsActionsEnum.DELETE_ANALYTICS_SUCCESS } as const)

export const deleteAnalyticsErrorAction = () =>
  ({ type: AnalyticsActionsEnum.DELETE_ANALYTICS_ATTEMPT } as const)

export const getAnalyticsAttemptAction = () =>
  ({ type: AnalyticsActionsEnum.GET_ANALYTICS_ATTEMPT } as const)

export const getAnalyticsSuccessAction = (analytics: Analytic[]) =>
  ({
    type: AnalyticsActionsEnum.GET_ANALYTICS_SUCCESS,
    payload: analytics,
  } as const)

export const getAnalyticsErrorAction = () =>
  ({ type: AnalyticsActionsEnum.GET_ANALYTICS_ATTEMPT } as const)

export const importFromFulllAttemptAction = () =>
  ({ type: AnalyticsActionsEnum.IMPORT_FROM_FULLL_ANALYTICS_ATTEMPT } as const)

export const importFromFulllSuccessAction = () =>
  ({
    type: AnalyticsActionsEnum.IMPORT_FROM_FULLL_ANALYTICS_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "analytics_axes.toaster.title",
      bodyKey: "analytics_axes.toaster.body",
    },
  } as const)

export const importFromFulllErrorAction = () =>
  ({
    type: AnalyticsActionsEnum.IMPORT_FROM_FULLL_ANALYTICS_ERROR,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "analytics_axes.toaster.error.title",
      bodyKey: "analytics_axes.toaster.error.body",
    },
  } as const)

export const editAnalyticsAction = (analytics: Analytic) =>
  ({
    type: AnalyticsActionsEnum.EDIT_ANALYTIC,
    payload: analytics,
  } as const)

type AnalyticsActionsType = ReturnType<
  | typeof addAnalyticsAttemptAction
  | typeof addAnalyticsSuccessAction
  | typeof addAnalyticsErrorAction
  | typeof addAnalyticsTooLongErrorAction
  | typeof updateAnalyticsAttemptAction
  | typeof updateAnalyticsSuccessAction
  | typeof updateAnalyticsErrorAction
  | typeof deleteAnalyticsAttemptAction
  | typeof deleteAnalyticsSuccessAction
  | typeof deleteAnalyticsErrorAction
  | typeof getAnalyticsAttemptAction
  | typeof getAnalyticsSuccessAction
  | typeof getAnalyticsErrorAction
  | typeof importFromFulllAttemptAction
  | typeof importFromFulllSuccessAction
  | typeof importFromFulllErrorAction
  | typeof editAnalyticsAction
>

export const analyticsInitialState: AnalyticsState = {
  analytics: [],
  editedAnalytics: [],
}

export interface AnalyticsState {
  analytics: Analytic[]
  editedAnalytics: Analytic[]
}

export function analyticsReducer(
  state = analyticsInitialState,
  action: AnalyticsActionsType
): AnalyticsState {
  switch (action.type) {
    case AnalyticsActionsEnum.ADD_ANALYTICS_ATTEMPT:
      return { ...state }
    case AnalyticsActionsEnum.GET_ANALYTICS_SUCCESS:
      return { ...state, analytics: action.payload, editedAnalytics: [] }
    case AnalyticsActionsEnum.EDIT_ANALYTIC:
      const filteredEditedAnalytics = state.editedAnalytics.filter(
        (analytic) => analytic.id !== action.payload.id
      )
      return {
        ...state,
        editedAnalytics: [...filteredEditedAnalytics, action.payload],
      }
    default:
      return { ...state }
  }
}

export const addAnalyticsThunk =
  ({ companyId, analytics }: { companyId: number; analytics: string[] }) =>
  (dispatch: Dispatch<AnalyticsActionsType | RNBThunkAction>) => {
    const cleanedAnalytics = analytics.filter((a) => Boolean(a))
    dispatch(addAnalyticsAttemptAction())
    return axios
      .post(`analytics/add_analytics`, {
        company_id: companyId,
        analytics: cleanedAnalytics,
      })
      .then(({ data }) => {
        dispatch(addAnalyticsSuccessAction())
        dispatch(getAnalyticsThunk({ companyId }))
      })
      .catch((error) => {
        const errorData = error.response?.data?.error
        if (errorData) {
          if (
            typeof errorData === "object" &&
            errorData.type === "analytic_too_long"
          ) {
            dispatch(
              addAnalyticsTooLongErrorAction({
                current_length: errorData.current_length,
                limit: errorData.limit,
                accounting_software: errorData.accounting_software,
              })
            )
          } else if (
            typeof errorData === "string" &&
            errorData === "analytic is too long"
          ) {
            dispatch(addAnalyticsTooLongErrorAction())
          } else {
            dispatch(addAnalyticsErrorAction())
          }
        } else {
          dispatch(addAnalyticsErrorAction())
        }
      })
  }

export const deleteAnalyticsThunk =
  ({ companyId, analytic }: { companyId: number; analytic: Analytic }) =>
  (dispatch: Dispatch<AnalyticsActionsType | RNBThunkAction>) => {
    dispatch(deleteAnalyticsAttemptAction())
    return axios
      .delete(`analytics/delete_analytic`, { params: { id: analytic.id } })
      .then(() => {
        dispatch(deleteAnalyticsSuccessAction())
        dispatch(getAnalyticsThunk({ companyId }))
      })
      .catch(() => {
        dispatch(deleteAnalyticsErrorAction())
      })
  }

export const updateAnalyticsThunk =
  ({ companyId, analytics }: { companyId: number; analytics: Analytic[] }) =>
  (dispatch: Dispatch<AnalyticsActionsType | RNBThunkAction>) => {
    const cleanedAnalytics = analytics.filter((a) => Boolean(a))
    dispatch(updateAnalyticsAttemptAction())
    return axios
      .put(`analytics/update_analytics`, {
        analytics: cleanedAnalytics.map((a) => ({
          id: a.id,
          description: a.description,
        })),
      })
      .then(() => {
        dispatch(updateAnalyticsSuccessAction())
        dispatch(getAnalyticsThunk({ companyId }))
      })
      .catch(() => {
        dispatch(updateAnalyticsErrorAction())
      })
  }

export const getAnalyticsThunk =
  ({ companyId }: { companyId: number }) =>
  (dispatch: Dispatch<AnalyticsActionsType>) => {
    dispatch(getAnalyticsAttemptAction())
    return axios
      .get<Analytic[]>(`analytics/get_analytics`, {
        params: {
          company_id: companyId,
        },
      })
      .then(({ data }) => {
        dispatch(getAnalyticsSuccessAction(data))
      })
      .catch(() => {
        dispatch(getAnalyticsErrorAction())
      })
  }

export const importFromFulllThunk =
  ({ companyId }: { companyId: number }) =>
  (dispatch: Dispatch<AnalyticsActionsType | RNBThunkAction>) => {
    dispatch(importFromFulllAttemptAction())
    return axios
      .put(`analytics/import_from_fulll`, {
        company_id: companyId,
      })
      .then(() => {
        dispatch(importFromFulllSuccessAction())
        dispatch(getAnalyticsThunk({ companyId }))
      })
      .catch(() => {
        dispatch(importFromFulllErrorAction())
      })
  }

export const configureMerchantAnalyticThunk =
  ({
    companyId,
    merchantId,
    analyticId,
  }: {
    companyId: number
    merchantId: number
    analyticId: number | null
  }) =>
  (dispatch: Dispatch<AnalyticsActionsType | RNBThunkAction>) => {
    return axios
      .put<Analytic[]>(`analytics/configure_merchant_analytic`, {
        company_id: companyId,
        merchant_id: merchantId,
        analytic_id: analyticId,
      })
      .then(({ data }) => {
        dispatch(getAnalyticsThunk({ companyId }))
      })
      .catch(() => {})
  }
